export default function (string) {
  if (typeof string === 'string' && string.length > 0) {
    return string.split('_').join(' ');
  }

  return string;
}
